<template>
  <div class="logout-box">
    <div>
    	<p class="logged-user">Logged in as {{firstName}} {{lastName}} <el-button @click.native="logout"  size="small">Logout</el-button></p>
    	
    </div>
  </div>
</template>

<script>
export default {
  name: 'logout',
  data () {
    return {
      firstName: null,
      lastName:null
    }
  },
  methods:{
  	logout: function(){
  		var _this = this;
  		Parse.User.logOut().then(function(){
  			_this.$router.push('/login');
  		})
  		
  		
  	}
  },
  mounted: function(){
  	if(Parse.User.current()){
  		console.log('GOT CURRENT USER');
  		var user = Parse.User.current()
  		console.log(user);
  		if(user){
  			this.firstName =  user.get('firstName');
  			this.lastName =  user.get('lastName');
  		} 

  	} else {
  		this.$router.push('/signup/');
  	}
  	// var user = Parse.User.current();
  	// this.user = user;
  }
}
</script>

<style>
.logout-box {
	display: block;
	margin: 10px auto 50px;
}
.logged-user {
	font-size: 14px;
	color: #999;

}
</style>
